"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalLinkIcon = void 0;
const react_1 = __importDefault(require("react"));
const ExternalLinkIcon = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement("svg", Object.assign({ width: "17", height: "17", viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M12.75 9.20833V13.4583C12.75 13.8341 12.6007 14.1944 12.3351 14.4601C12.0694 14.7257 11.7091 14.875 11.3333 14.875H3.54167C3.16594 14.875 2.80561 14.7257 2.53993 14.4601C2.27426 14.1944 2.125 13.8341 2.125 13.4583V5.66667C2.125 5.29094 2.27426 4.93061 2.53993 4.66493C2.80561 4.39926 3.16594 4.25 3.54167 4.25H7.79167", stroke: "#66A0CA", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M10.625 2.125H14.875V6.375", stroke: "#66A0CA", strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M7.08325 9.91667L14.8749 2.125", stroke: "#66A0CA", strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.ExternalLinkIcon = ExternalLinkIcon;
